














































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import { ValidationProvider } from "vee-validate";

@Component({
  components: { ValidationProvider },
  inheritAttrs: false,
})
export default class MyDateTimePickerMobile extends Vue {
  @Prop({ default: "" }) label?: string;
  @Prop({ default: "" }) value: string;
  @Prop({ default: "" }) rules!: string;
  @Prop({ default: null }) min?: string;
  @Prop({ default: null }) max?: string;
  @Prop({ default: null }) invalidMsg?: string;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: () => ({ clearable: false }) }) options?: any;

  showDatePicker = false;
  showTimePicker = false;

  datePart: string | null = null;
  timePart: string | null = "00:00";

  formattedDate = "";

  created() {
    this.updateParts(this.value);
  }

  @Watch("value")
  onValueChange(newVal: string) {
    this.updateParts(newVal);
  }

  updateParts(val: string) {
    if (val) {
      this.formattedDate = moment(val).format("DD-MM-YYYY HH:mm");
      this.datePart = moment(val).format("YYYY-MM-DD");
      this.timePart = moment(val).format("HH:mm");
    } else {
      this.formattedDate = "";
      this.datePart = moment().format("YYYY-MM-DD");
      this.timePart = "00:00";
    }
  }

  onDateSelected() {
    this.showDatePicker = false;
    if (this.datePart) {
      if (!this.timePart) {
        this.timePart = "00:00";
      }
      this.showTimePicker = true;
    }
  }

  onTimeSelected() {
    this.showTimePicker = false;
    if (this.datePart && this.timePart) {
      const newDateTime = moment(
        `${this.datePart} ${this.timePart}`,
        "YYYY-MM-DD HH:mm"
      ).format("YYYY-MM-DDTHH:mm:ssZ");
      this.$emit("input", newDateTime);
    }
  }

  clearDate() {
    this.formattedDate = "";
    this.datePart = moment().format("YYYY-MM-DD");
    this.timePart = "00:00";
    this.$emit("input", null);
  }
}
